<div class="card dialog-box dialogue-width">
  <div class="card-header">
    Casual User Activity
    <span class="float-end" (click)="onDismiss()"
      ><i class="fa-solid fa-xmark"></i
    ></span>
  </div>

  <div class="overflow-45vh px-2 px-lg-5 pb-4">
    @for (item of reservedBillingDetails?.billing_details; track $index) {
      <div class="mb-4">
        <div class="gap-2 sticky-header">
          <div>{{ item?.updated_date | date: "d MMM" }}</div>
          <div>{{ item?.billing_info?.length }}</div>
        </div>

        <div class="p-2 ps-5 d-flex gap-2 flex-column">
          @for (user of item?.billing_info; track $index) {
            <li>
              {{ user?.user_name }}
            </li>
          }
        </div>
      </div>
    }
  </div>

  <div class="gap-2 total-info px-2 px-lg-5 pt-4">
    <div>Total</div>
    <div>
      {{ reservedBillingDetails?.total_count }} ( {{ regionCurrencySymbol
      }}{{ reservedBillingDetails?.total_amount }} =
      {{ reservedBillingDetails?.total_count }} * {{ regionCurrencySymbol
      }}{{ reservedBillingDetails?.per_day_per_guard_price }} )
    </div>
  </div>
</div>
